<template>
  <div class="memo-center">
    <!-- 左侧时间导航菜单 -->
    <div class="sidebar">
      <el-card class="nav-card" shadow="never">
        <div class="nav-header">
          <h3 class="nav-title">备忘中心</h3>
          <p class="nav-subtitle">按时间管理</p>
        </div>
        <el-menu 
          default-active="0" 
          class="nav-menu" 
          @select="findItem"
        >
          <el-menu-item 
            v-for="(menu, i) in menuInfo" 
            :key="i" 
            :index="i + ''"
          >
            <i class="el-icon-date"></i>
            <span>{{ menu.time }}</span>
                </el-menu-item>
          </el-menu>
      </el-card>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="content-section">
        <el-card class="content-card" shadow="always">
          <div class="card-header">
            <div class="header-info">
              <h2 class="section-title">备忘列表</h2>
              <el-tag type="info" size="small" class="count-tag">
                共 {{ memoList.length }} 条备忘
              </el-tag>
            </div>
            <div class="header-actions">
              <el-button 
                type="primary" 
                icon="el-icon-plus"
                @click="dialogFormVisible = true"
                class="add-btn"
              >
                新建备忘
              </el-button>
            </div>
          </div>

          <!-- 备忘卡片网格 -->
          <div class="memo-grid" v-if="memoList.length > 0">
            <div 
              v-for="(memo, i) in memoList" 
              :key="i" 
              class="memo-card-wrapper"
            >
              <el-card 
                class="memo-card" 
                :class="{ 'completed': memo.state, 'pending': !memo.state }"
                shadow="hover"
              >
                <!-- 卡片头部 -->
                <div class="memo-header">
                  <div class="memo-title-section">
                    <div class="memo-icon">
                      <i :class="memo.state ? 'el-icon-check' : 'el-icon-document'"></i>
                    </div>
                    <div class="memo-title-content">
                      <div class="title-row">
                        <h3 class="memo-title">{{ memo.title }}</h3>
                        <el-tag 
                          :type="memo.state ? 'success' : 'warning'" 
                          size="mini"
                          class="status-tag"
                        >
                          {{ memo.state ? '已完成' : '进行中' }}
                        </el-tag>
                      </div>
                      <div class="memo-meta">
                        <span class="memo-date">
                          <i class="el-icon-time"></i>
                          {{ formatDate(memo.time) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="memo-actions">
                    <el-switch 
                      v-model="memo.state" 
                      active-color="#67C23A" 
                      inactive-color="#F56C6C" 
                      @change="stateChange(memo)"
                      class="status-switch"
                    />
                  </div>
                </div>
                
                <!-- 卡片内容 -->
                <div class="memo-content">
                  <div class="content-wrapper">
                    <el-input
                        type="textarea"
                      :autosize="{ minRows: 4, maxRows: 6 }"
                      v-model="memo.text"
                      class="memo-textarea"
                      placeholder="请输入备忘内容..."
                      :class="{ 'completed-text': memo.state }"
                    />
                  </div>
                </div>
                
                <!-- 卡片底部 -->
                <div class="memo-footer">
                  <div class="footer-left">
                    <span class="memo-id">#{{ memo.id }}</span>
                  </div>
                  <div class="footer-right">
                    <el-button 
                      :type="deleteType(memo)" 
                      size="mini"
                      icon="el-icon-delete"
                      @click="deleteBeforeMemo(memo)"
                      class="delete-btn"
                      circle
                    />
                  </div>
                </div>

                <!-- 完成状态遮罩 -->
                <div v-if="memo.state" class="completion-overlay">
                  <i class="el-icon-check"></i>
                </div>
                </el-card>
            </div>
        </div>

          <!-- 空状态 -->
          <div v-else class="empty-state">
            <i class="el-icon-document-copy"></i>
            <p>暂无备忘记录</p>
            <el-button 
              type="primary" 
              icon="el-icon-plus"
              @click="dialogFormVisible = true"
            >
              创建第一个备忘
            </el-button>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 新建备忘对话框 -->
    <el-dialog 
      title="新建备忘" 
      :visible.sync="dialogFormVisible"
      width="600px"
      class="custom-dialog"
    >
      <el-form :model="newMemo" label-width="120px" class="dialog-form">
        <el-form-item label="备忘标题">
          <el-input 
            placeholder="请输入备忘标题" 
            v-model="newMemo.title" 
            clearable 
          />
        </el-form-item>
        <el-form-item label="截止日期">
          <el-date-picker 
            v-model="newMemo.time" 
            type="date" 
            placeholder="选择截止日期"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="备忘内容">
          <el-input 
            type="textarea" 
            :autosize="{ minRows: 6, maxRows: 8 }" 
            v-model="newMemo.text"
            placeholder="请输入备忘内容..."
          />
        </el-form-item>
      </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="creatMemo">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import { memoApi } from '@/api'

export default {
  name: 'MemoCenter',
  data () {
    return {
      dialogFormVisible: false,
      newMemo: {
        title: '',
        text: '',
        time: ''
      },
      memoList: [],
      menuInfo: []
    }
  },
  mounted () {
    this.getMemoTime()
  },
  methods: {
    // 格式化日期
    formatDate (dateString) {
      if (!dateString) return '未设置'
      const date = new Date(dateString)
      const now = new Date()
      const diffTime = date - now
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      
      if (diffDays === 0) {
        return '今天'
      } else if (diffDays === 1) {
        return '明天'
      } else if (diffDays > 1) {
        return `${diffDays} 天后`
      } else {
        return '今天'
      }
    },

    // 获取删除按钮类型
    deleteType (memo) {
      if (memo.state === true) return 'success'
      if (memo.state === false) return 'danger'
      return 'primary'
    },

    async deleteMemo (memo) {
      try {
        await memoApi.deleteMemo(memo.id)
        this.$message.success('删除备忘成功！')
        this.getMemoTime()
        this.findItemByTime(memo.time)
      } catch (error) {
        console.error('删除备忘失败:', error)
      }
    },
    deleteBeforeMemo (memo) {
      this.$confirm('是否删除备注  ' + memo.title + '  ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteMemo(memo)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    findItem (key, keyPath) {
      this.findItemByTime(this.menuInfo[key].time)
    },
    async findItemByTime (time) {
      try {
        const response = await memoApi.findMemo(time)
        this.memoList = response
        for (let i in this.memoList) {
          if (this.memoList[i].state === 0) this.memoList[i].state = false
          else this.memoList[i].state = true
        }
      } catch (error) {
        console.error('获取备忘失败:', error)
      }
    },
    async creatMemo () {
      try {
        await memoApi.creatMemo(this.newMemo)
        this.$message.success('新建备忘成功！')
        this.dialogFormVisible = false
        this.getMemoTime()
      } catch (error) {
        console.error('创建备忘失败:', error)
      }
    },
    async getMemoTime () {
      try {
        const response = await memoApi.getMemoTime()
        let timeList = response
        this.menuInfo = []
        for (let i in timeList) {
          let s = timeList[i]
          let time = s.substring(0, s.indexOf(' '))
          this.menuInfo.push({time: time})
        }
      } catch (error) {
        console.error('获取备忘时间失败:', error)
      }
    },
    async stateChange (memo) {
      let nextState = ''
      if (memo.state === true) {
        nextState = '已完成'
      } else {
        nextState = '未完成'
      }
      try {
        await memoApi.changeState(memo.id)
        this.$message.success('成功更改备忘 ' + memo.title + ' 的状态为 ' + nextState)
      } catch (error) {
        console.error('更改备忘状态失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.memo-center {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
  gap: 20px;
  padding: 20px;
}

/* 左侧导航栏 */
.sidebar {
  width: 280px;
  flex-shrink: 0;
}

.nav-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.nav-header {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.nav-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.nav-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.nav-menu {
  border: none;
}

.nav-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-menu .el-menu-item:hover {
  background-color: #ECF5FF;
  color: #409EFF;
}

.nav-menu .el-menu-item.is-active {
  background-color: #409EFF;
  color: white;
}

.nav-menu .el-menu-item i {
  margin-right: 12px;
  font-size: 16px;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  min-width: 0;
}

.content-section {
  width: 100%;
}

.content-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.count-tag {
  background-color: #F4F4F5;
  color: #909399;
  border: none;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.add-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 备忘网格 */
.memo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 24px;
  padding: 20px 0;
}

.memo-card-wrapper {
  min-height: 320px;
}

.memo-card {
  height: 100%;
  border-radius: 12px;
  border: 1px solid #e8f4fd;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background: #ffffff;
}

.memo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.15);
  border-color: #409EFF;
}

.memo-card.completed {
  background: #ffffff;
  border-left: 3px solid #67C23A;
  border-color: rgba(103, 194, 58, 0.2);
}

.memo-card.completed:hover {
  box-shadow: 0 8px 25px rgba(103, 194, 58, 0.15);
  border-color: #67C23A;
}

.memo-card.pending {
  background: #ffffff;
  border-left: 3px solid #E6A23C;
  border-color: rgba(230, 162, 60, 0.2);
}

.memo-card.pending:hover {
  box-shadow: 0 8px 25px rgba(230, 162, 60, 0.15);
  border-color: #E6A23C;
}

/* 备忘卡片头部 */
.memo-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
}

.memo-title-section {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
}

.memo-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f9ff;
  color: #409EFF;
  font-size: 16px;
  flex-shrink: 0;
  border: 1px solid rgba(64, 158, 255, 0.2);
}

.memo-card.completed .memo-icon {
  background: #f0f9ff;
  color: #67C23A;
  border-color: rgba(103, 194, 58, 0.2);
}

.memo-card.pending .memo-icon {
  background: #f0f9ff;
  color: #E6A23C;
  border-color: rgba(230, 162, 60, 0.2);
}

.memo-title-content {
  flex: 1;
  min-width: 0;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.memo-title {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  line-height: 1.3;
  word-break: break-word;
  flex: 1;
  min-width: 0;
}

.memo-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.memo-date {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #606266;
  background: #f5f7fa;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}

.memo-date i {
  font-size: 12px;
  color: #909399;
}

.status-tag {
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  padding: 4px 8px;
  flex-shrink: 0;
}

.memo-actions {
  flex-shrink: 0;
  margin-left: 12px;
}

.status-switch {
  transform: scale(0.9);
}

/* 备忘内容 */
.memo-content {
  margin-bottom: 20px;
}

.content-wrapper {
  position: relative;
}

.memo-textarea {
  border-radius: 12px;
}

.memo-textarea .el-textarea__inner {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  font-size: 15px;
  line-height: 1.7;
  transition: all 0.3s ease;
  background: #fafafa;
  resize: none;
  font-weight: 400;
  color: #2c3e50;
}

.memo-textarea .el-textarea__inner:focus {
  border-color: #409EFF;
  background: white;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
  font-weight: 500;
}

.memo-textarea.completed-text .el-textarea__inner {
  background: #f8f9fa;
  border-color: rgba(103, 194, 58, 0.3);
  color: #606266;
  font-weight: 400;
}

/* 备忘底部 */
.memo-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.footer-left {
  display: flex;
  align-items: center;
}

.memo-id {
  font-size: 11px;
  color: #bdc3c7;
  font-weight: 600;
  background: rgba(189, 195, 199, 0.1);
  padding: 4px 8px;
  border-radius: 8px;
}

.footer-right {
  display: flex;
  align-items: center;
}

.delete-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
    font-size: 14px;
  }

.delete-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 完成状态遮罩 */
.completion-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  background: #67C23A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  opacity: 0.9;
  z-index: 1;
  box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
}

.completion-overlay i {
  transform: none;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-state i {
  font-size: 64px;
  color: #C0C4CC;
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 16px;
  margin-bottom: 20px;
}

/* 对话框样式 */
.custom-dialog .el-dialog {
  border-radius: 12px;
}

.custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 20px;
}

.custom-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.custom-dialog .el-dialog__body {
  padding: 30px;
}

.dialog-form .el-form-item {
  margin-bottom: 20px;
}

.dialog-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .memo-center {
    flex-direction: column;
    gap: 15px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .nav-menu {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .nav-menu .el-menu-item {
    margin: 4px 8px;
  }
}

@media (max-width: 768px) {
  .memo-center {
    padding: 10px;
  }
  
  .memo-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .memo-card-wrapper {
    min-height: 280px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .memo-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .memo-title-section {
    width: 100%;
  }
  
  .memo-actions {
    align-self: flex-end;
    margin-left: 0;
  }
  
  .memo-icon {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .title-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .memo-title {
    font-size: 18px;
  }
  
  .memo-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .completion-overlay {
    width: 28px;
    height: 28px;
    font-size: 14px;
    top: 8px;
    right: 8px;
  }
  
  .custom-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .nav-menu {
    flex-direction: column;
  }
  
  .nav-menu .el-menu-item {
    margin: 2px 0;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .count-tag {
    font-size: 11px;
  }
  
  .memo-title span {
    font-size: 14px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/views/memo/MemoCenter.vue